import React, { useEffect, useState } from 'react';
import { Drawer, IconButton, List, ListItemButton, ListItemText, Collapse, Box, Fade } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Link, useLocation } from 'react-router-dom';
import { pesquisaMenuItems, type PesquisaMenuItem } from './menuPesquisaItems';

const MobileDrawerMenu: React.FC = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openSobre, setOpenSobre] = useState(false);
  const [openEstudante, setOpenEstudante] = useState(false);
  const [openContato, setOpenContato] = useState(false);
  const [openCursos, setOpenCursos] = useState(false);
  const [openPesquisa, setOpenPesquisa] = useState(false);
  const { pathname } = useLocation();

  const closeAll = () => {
    setOpenDrawer(false);
    setOpenSobre(false);
    setOpenCursos(false);
    setOpenEstudante(false);
    setOpenPesquisa(false);
    setOpenContato(false);
  };

  const renderPesquisaItems = (items: PesquisaMenuItem[], depth = 0): React.ReactNode =>
    items.map((item) => (
      <React.Fragment key={item.path}>
        <ListItemButton sx={{ pl: 4 + depth * 2 }} component={Link} to={item.path} onClick={closeAll}>
          <ListItemText
            primary={item.label}
            primaryTypographyProps={{
              fontWeight: item.children?.length ? 700 : 400,
              fontSize: depth > 0 ? 14 : undefined,
            }}
          />
        </ListItemButton>
        {item.children?.length ? renderPesquisaItems(item.children, depth + 1) : null}
      </React.Fragment>
    ));
  useEffect(() => {
    closeAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <>
      <IconButton
        edge="start"
        color="inherit"
        onClick={() => setOpenDrawer(true)}
        aria-label="menu"
        className="mobile-menu-button"
      >
        <MenuIcon />
      </IconButton>

      <Drawer anchor="left" open={openDrawer} onClose={() => setOpenDrawer(false)} ModalProps={{ keepMounted: true }}>
        <Box sx={{ width: 260 }} role="presentation">
          <List>
            <ListItemButton onClick={() => setOpenSobre(!openSobre)}>
              <ListItemText primary="A Faculdade" />
              {openSobre ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openSobre} timeout={200} unmountOnExit>
              <Fade in={openSobre} timeout={220} mountOnEnter unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton sx={{ pl: 4 }} component={Link} to="/sobre" onClick={closeAll}>
                    <ListItemText primary="Quem Somos" />
                  </ListItemButton>
                  <ListItemButton sx={{ pl: 4 }} component={Link} to="/mantenedora" onClick={closeAll}>
                    <ListItemText primary="Mantenedora" />
                  </ListItemButton>
                  <ListItemButton sx={{ pl: 4 }} component={Link} to="/estrutura" onClick={closeAll}>
                    <ListItemText primary="Estrutura Física" />
                  </ListItemButton>
                </List>
              </Fade>
            </Collapse>

            <ListItemButton onClick={() => setOpenCursos(!openCursos)}>
              <ListItemText primary="Cursos" />
              {openCursos ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openCursos} timeout={200} unmountOnExit>
              <Fade in={openCursos} timeout={220} mountOnEnter unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton sx={{ pl: 4 }} component={Link} to="/graduacao" onClick={closeAll}>
                    <ListItemText primary="Graduação" />
                  </ListItemButton>
                  <ListItemButton sx={{ pl: 4 }} component={Link} to="/pos-graduacao" onClick={closeAll}>
                    <ListItemText primary="Pós-Graduação" />
                  </ListItemButton>
                  <ListItemButton sx={{ pl: 4 }} component={Link} to="/extensao" onClick={closeAll}>
                    <ListItemText primary="Extensão Universitária" />
                  </ListItemButton>
                </List>
              </Fade>
            </Collapse>

            <ListItemButton onClick={() => setOpenEstudante(!openEstudante)}>
              <ListItemText primary="Área do Aluno" />
              {openEstudante ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openEstudante} timeout={200} unmountOnExit>
              <Fade in={openEstudante} timeout={220} mountOnEnter unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton sx={{ pl: 4 }} component={Link} to="/secretaria/secad" onClick={closeAll}>
                    <ListItemText primary="Secretaria Acadêmica" />
                  </ListItemButton>
                  <ListItemButton sx={{ pl: 4 }} component={Link} to="/secretaria/servicos-aluno" onClick={closeAll}>
                    <ListItemText primary="Serviços ao Aluno" />
                  </ListItemButton>
                  <ListItemButton sx={{ pl: 4 }} component={Link} to="/biblioteca/ambiente" onClick={closeAll}>
                    <ListItemText primary="Biblioteca Física" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    component="a"
                    href="https://cachola.senac.br/?locale=pt&locale=pt"
                    target="_blank"
                    rel="noopener"
                    onClick={closeAll}
                  >
                    <ListItemText primary="Cachola" />
                  </ListItemButton>
                  <ListItemButton sx={{ pl: 4 }} component={Link} to="/nucleo-apoio" onClick={closeAll}>
                    <ListItemText primary="Núcleo de Apoio" />
                  </ListItemButton>
                </List>
              </Fade>
            </Collapse>

            <ListItemButton onClick={() => setOpenPesquisa(!openPesquisa)}>
              <ListItemText primary="Pesquisa e Inovação" />
              {openPesquisa ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openPesquisa} timeout={200} unmountOnExit>
              <Fade in={openPesquisa} timeout={220} mountOnEnter unmountOnExit>
                <List component="div" disablePadding>
                  {renderPesquisaItems(pesquisaMenuItems)}
                </List>
              </Fade>
            </Collapse>

            <ListItemButton component={Link} to="/revista" onClick={closeAll}>
              <ListItemText primary="Revista" />
            </ListItemButton>

            <ListItemButton component={Link} to="/cpa/sobre" onClick={closeAll}>
              <ListItemText primary="CPA" />
            </ListItemButton>

            <ListItemButton onClick={() => setOpenContato(!openContato)}>
              <ListItemText primary="Fale Conosco" />
              {openContato ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openContato} timeout={200} unmountOnExit>
              <Fade in={openContato} timeout={220} mountOnEnter unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton sx={{ pl: 4 }} component={Link} to="/contato" onClick={closeAll}>
                    <ListItemText primary="Contato" />
                  </ListItemButton>
                  <ListItemButton sx={{ pl: 4 }} component={Link} to="/ouvidoria" onClick={closeAll}>
                    <ListItemText primary="Ouvidoria" />
                  </ListItemButton>
                  <ListItemButton sx={{ pl: 4 }} component={Link} to="/faq" onClick={closeAll}>
                    <ListItemText primary="Dúvidas Frequentes" />
                  </ListItemButton>
                </List>
              </Fade>
            </Collapse>
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default MobileDrawerMenu;
